import { getAddress } from '@ethersproject/address'


export const templateId = process.env.REACT_APP_TEMPLATE_TYPE

// returns the checksummed address if the address is valid, otherwise returns false
export function isAddress(value: any): string | false {
  try {
    return getAddress(value)
  } catch {
    return false
  }
}

// shorten the address
export function shortenAddress(address: string, chars = 4): string {
  return `${address.substring(0, chars)}...${address.substring(address.length - chars, address.length)}`
}
